/**
 * English UI copy for the Watch List section.
 * i18n namespace files are added later by the translation bot. Do not add
 * watchList.json under src/assets/i18n on this branch.
 */
export const WATCH_LIST_COPY = {
  title: 'Watch List',
  header: {
    collapse: 'Collapse',
    expand: 'Expand',
  },
  table: {
    portfolio: 'Portfolio',
    accountType: 'Account type',
    reason: 'Reason',
    custodian: 'Custodian',
    value: 'Value',
    bandConsumed: 'Band consumed',
    threshold: 'Threshold',
  },
  empty: {
    title: 'No accounts approaching threshold.',
  },
  footer: {
    configure: 'Configure',
  },
} as const;

export function formatApproachingCount(count: number): string {
  return `${count} approaching`;
}

export function formatThresholdSummary(percent: number): string {
  return `Accounts within ${percent}% of drift threshold — monitor, no action required today`;
}

export function formatFooterRowCount(count: number): string {
  return count === 1 ? `Showing ${count} account` : `Showing ${count} accounts`;
}

export function formatFooterThreshold(percent: number): string {
  return `Threshold: ${percent}% band consumed`;
}
